import { styled } from "@woba/ds-web";

export const PerformanceIndicatorContainerWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

export const PerformanceIndicatorItem = styled("div", {
  display: "flex",
  marginBottom: "$space-02 ",
  alignItems: "center",

  span: {
    textTransform: "uppercase",
    fontSize: "$sm",
    fontStyle: "normal",
    fontWeight: 500,
    color: "$neutral-700",
    letterSpacing: "1.2px",
    lineHeight: 0,
  },
});
export const PerformanceIndicatorItemBullet = styled("div", {
  width: 12,
  height: 12,
  borderRadius: "50%",
  marginRight: "$space-03",
});

export const EmptyRating = styled("div", {
  display: "flex",
  alignItems: "center",

  fontSize: "$md",
  fontStyle: "normal",
  fontWeight: 500,

  svg: {
    width: 14,
    height: 14,
    color: "$neutral-700",
    marginLeft: "$space-03",
  },
  span: {
    display: "flex",
  },
});
